import sbjs from "sourcebuster";
import UAParser from "ua-parser-js";
import Cookies from "js-cookie";

export const makeAnalytics = () => {
  const noop = (a?: any, b?: any, c?: any, d?: any) => {};
  const getCookieValue = (name: string) => {
    const re = new RegExp(name + "=([^;]+)");
    const value = re.exec(document.cookie);
    if (value != null) {
      const newVal = unescape(value[1]);
      if (newVal.indexOf("GA1.2.") !== -1) {
        return newVal.replace("GA1.2.", "");
      }
    }
    return value != null ? unescape(value[1]) : null;
  };

  // @ts-ignore
  const analytics = window.analytics || {
    identify: noop,
    page: noop,
    track: noop
  };

  const gtm = {
    pushData(data: any) {
      // @ts-ignore
      const dataLayer = window.dataLayer || [];
      dataLayer.push(data);
    },
    eventCall(event: any, data: any) {
      let eventData = {
        event,
        ...data
      };
      this.pushData(eventData);
      if (!(<any>window).google_tag_manager && data.eventCallback) {
        data.eventCallback("GTM-KT9XPJ");
      }
    }
  };

  const userAgent = new UAParser().getResult();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  sbjs.init({
    referrals: [
      {
        host: "bing.com",
        medium: "organic"
      }
    ]
  });

  const [utm_term, utm_term_first] = [
    sbjs.get.current.trm || urlParams.get("utm_term") || "",
    sbjs.get.current.trm || ""
  ];

  const utm = {
    current: {
      utm_campaign: sbjs.get.current.cmp || urlParams.get("campaign"),
      utm_content: sbjs.get.current.cnt || urlParams.get("utm_content"),
      utm_medium: sbjs.get.current.mdm || urlParams.get("utm_medium"),
      utm_source: sbjs.get.current.src || urlParams.get("utm_source"),
      utm_keyword: utm_term.split("+").join(" "),
      utm_type: sbjs.get.current.typ,
      ep: sbjs.get.current_add.ep,
      registration_url: document.URL,
      gclid: Cookies.get("adm_analytics_gclid"),
      fbclid: Cookies.get("adm_analytics_fbclid"),
      msclkid: Cookies.get("adm_analytics_msclkid"),
      utm_sub_id: urlParams.get("sub_id") || Cookies.get("sub_id") || ""
    },
    first: {
      utm_campaign: sbjs.get.first.cmp,
      utm_content: sbjs.get.first.cnt,
      utm_medium: sbjs.get.first.mdm,
      utm_source: sbjs.get.first.src,
      utm_keyword: utm_term_first.split("+").join(" "),
      utm_type: sbjs.get.first.typ,
      ep: sbjs.get.first_add.ep,
      registration_url: document.URL,
      gclid: Cookies.get("adm_analytics_gclid_first"),
      fbclid: Cookies.get("adm_analytics_fbclid_first"),
      msclkid: Cookies.get("adm_analytics_msclkid_first")
    },
    general: {
      visits: sbjs.get.udata.vst,
      device_type: userAgent.device.type ?? "desktop",
      device: userAgent.os.name,
      browser: userAgent.browser.name,
      gclid: getCookieValue("gclid"),
      ga_cid: getCookieValue("_ga")
    }
  };

  return {
    gtm,
    utm
  };
};

export type Analytics = ReturnType<typeof makeAnalytics>;
